import Svg, { Path, type SvgProps, type PathProps } from 'react-native-svg'

export function NoTransactionsIcon({
  svgProps,
  pathProps,
}: {
  svgProps?: SvgProps
  pathProps?: PathProps
}) {
  return (
    <Svg width={35} height={46} viewBox="0 0 35 46" fill="none" {...svgProps}>
      <Path
        d="M9.5 15h10.667M9.5 23h16m-4.387 19.664a4.704 4.704 0 01-7.226 0 4.704 4.704 0 00-6.675-.56L5.39 43.665c-1.528 1.31-3.89.224-3.89-1.789V9.666a8 8 0 018-8h16a8 8 0 018 8v32.21c0 2.014-2.362 3.1-3.89 1.79l-1.822-1.562a4.704 4.704 0 00-6.675.56z"
        stroke="#222"
        strokeWidth={2}
        strokeLinecap="round"
        {...pathProps}
      />
    </Svg>
  )
}
